import { render, staticRenderFns } from "./complaintFeedback.vue?vue&type=template&id=57f005e4&scoped=true&"
import script from "./complaintFeedback.vue?vue&type=script&lang=js&"
export * from "./complaintFeedback.vue?vue&type=script&lang=js&"
import style0 from "./complaintFeedback.vue?vue&type=style&index=0&id=57f005e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f005e4",
  null
  
)

export default component.exports